import { render } from "./Concern.vue?vue&type=template&id=a5bcf880"
import script from "./Concern.vue?vue&type=script&lang=js"
export * from "./Concern.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__